<template>
  <div class="task-history">
    <div class="task-history-container">
      <div class="task-history-header">
        Task history
      </div>
      <div class="task-history-body">
        <vuescroll :ops="scrollBarOptions" @handle-scroll="handleScroll" ref="historyMsg">
          <div class="task-history-body-row"
               :class="[{ mine: isMineMessage(message), 'not-sent': message.notSent }, 'message-type-' + message.type]"
               v-if="taskHistory.length"
               v-for="message in taskHistory">
            <div class="task-history-body-message">
              <div class="task-history-body-message-header">
                <span class="task-history-body-message-header-icon" v-if="message.type === 1">
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user"
                       class="svg-inline--fa fa-user fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 448 512">
                    <path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128
                          128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0
                          26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                  </svg>
                </span>
                <template v-if="getUserId === message.userId">You</template>
                <template v-else>{{ message.userName }}</template>
                <template v-if="message.clearOfficer"> (Clear Assured)</template>
                <template v-if="message.clearBot">Clear Bot</template>
                | {{ message.date }}
                <span class="task-history-body-message-header-not-sent" v-if="message.notSent">
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle"
                       class="svg-inline--fa fa-exclamation-circle fa-w-16" role="img"
                       xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043
                          8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595
                          46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373
                          0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884
                          0-12.356 5.78-11.981 12.654z"></path>
                  </svg>
                  Sending failed
                </span>
                <button class="task-history-body-message-header-not-sent-button"
                        v-if="message.notSent"
                        @click="retrySendMessage(message)">Retry</button>
              </div>
              <div class="task-history-body-message-content">
                <div class="task-history-body-message-text"
                     :class="{ 'delete-in-progress': deleteInProgress === message.id }"
                     v-if="message.type === 1">
                  <template v-if="message.deleted">
                    <i>Comment deleted by {{ message.deletedBy }} on {{ message.deletedOn }}</i>
                  </template>
                  <div v-else :inner-html.prop="message.text"></div>
                  <div class="task-history-body-message-files"
                       :class="{ 'has-text': message.text && message.text !== '' }"
                       v-if="message.files && message.files.length">
                    <div class="task-history-body-message-files-container">
                      <a href="#"
                         role="button"
                         @click.prevent="downloadFile(file, message.id)"
                         class="task-history-body-message-file"
                         v-for="file in message.files"
                         target="_blank">{{ file.file }}</a>
                    </div>
                  </div>
                </div>
                <div class="task-history-body-message-text"
                     v-else-if="message.type === 2">
                  <div class="task-history-body-message-status">
                    Changed status to
                    <span v-if="getStatusById(message.status)">
                        <span class="status-badge" :class="['status-' + getStatusById(message.status)['id']]">
                          <template v-if="getStatusById(message.status)['id'] === 1">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="dot-circle"
                                 class="svg-inline--fa fa-dot-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200
                                    0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0
                                    168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"></path>
                            </svg>
                          </template>
                          <template v-else-if="getStatusById(message.status)['id'] === 2">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner"
                                 class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512">
                              <path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48
                                    368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49
                                    48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49
                                    48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156
                                    0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48
                                    21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                            </svg>
                          </template>
                          <template v-else-if="getStatusById(message.status)['id'] === 3">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="eye"
                                 class="svg-inline--fa fa-eye fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 576 512">
                              <path fill="currentColor" d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4
                                    55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48
                                    241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0
                                    0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path>
                            </svg>
                          </template>
                          <template v-else-if="getStatusById(message.status)['id'] === 4">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                                 class="svg-inline--fa fa-check-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8
                                    256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532
                                    89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346
                                    303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068
                                    16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path>
                            </svg>
                          </template>
                          <span class="status-text">
                            {{ getStatusById(message.status)['name'] }}
                          </span>
                        </span>
                      </span>
                  </div>
                </div>
                <div class="task-history-body-message-text"
                     v-else-if="message.type === 3">
                  <div class="task-history-body-message-assignee">
                    Assigned to
                    <span>
                        <span class="assignee-badge">
                          <span class="assignee-badge-image">
                            <template v-if="message.assigneeImage || message.assigneeFullName">
                              <span v-if="message.assigneeImage" v-bind:style="{ backgroundImage: 'url(' + message.assigneeImage + ')' }"></span>
                              <avatar v-else :username="message.assigneeFullName" :size="29" color="#ffffff"></avatar>
                            </template>
                            <template v-else>
                              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle"
                                   class="svg-inline--fa fa-user-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                                   viewBox="0 0 496 512">
                                <path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0
                                    88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4
                                    55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1
                                    7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"></path>
                              </svg>
                            </template>
                          </span>
                          <span class="assignee-badge-text">
                            {{ message.assigneeName }}
                          </span>
                        </span>
                      </span>
                  </div>
                </div>
                <div class="task-history-body-message-text"
                     v-else-if="message.type === 4">
                  Moved to '{{ message.board }}'
                </div>
                <div class="task-history-body-message-actions"
                     v-if="isMineMessage(message) && message.type === 1 && !message.deleted">
                  <button v-if="!message.notSent && !message.clearBot" @click="deleteMessage(message)">Delete message</button>
                </div>
              </div>
            </div>
          </div>
          <div class="task-history-empty" v-if="!taskHistory.length">
            Nothing to see here just yet.<br />
            As soon as you start registering progress with this task, you will be able to see here the changes, as well as the messages you send or receive.
          </div>
        </vuescroll>
      </div>
      <form class="task-history-footer" @submit.prevent="messageSubmit">
        <div class="task-history-footer-textarea">
              <textarea name="First Name"
                        v-model="messageForm.text"
                        data-vv-as="Message"
                        v-validate="'required'"
                        rows="2"
                        placeholder="Type in your message..."
                        aria-label="Message"></textarea>
          <div class="task-history-footer-actions">
            <button type="submit" aria-label="Submit message" class="task-history-footer-actions-submit"
                    :class="{'not-empty': messageForm.text !== '' || messageForm.files.length, 'submitting': submitting}">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="paper-plane"
                   v-if="!submitting"
                   class="svg-inline--fa fa-paper-plane fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9
                          13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515
                          7.8 493.3-6.8 476 3.2z"></path>
              </svg>
              <svg v-if="submitting" aria-hidden="true" focusable="false" data-prefix="fad" data-icon="spinner-third" class="svg-inline--fa fa-spinner-third fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z"></path></g></svg>            </button>
          </div>
          <div class="task-history-footer-files" v-if="messageForm.files.length">
            <div class="task-history-footer-files-wrapper">
              <div class="task-history-footer-files-item" v-for="(file, index) in messageForm.files">
                {{ file.name }}
                <button type="button" @click="removeMessageFile(index)">
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                       class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 352 512">
                    <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19
                          0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48
                          0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24
                          22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                          0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="task-history-file-button">
      <label :for="'uploadResource_' + taskId">
        <span class="task-history-file-button-icon">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="paperclip"
               class="svg-inline--fa fa-paperclip fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 448 512">
            <path fill="currentColor" d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332
                        116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633
                        30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422
                        22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236
                        13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154
                        0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319
                        16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path>
          </svg>
        </span>
        <span class="task-history-file-button-text">Attach files</span>
        <input type="file"
               class="visually-hidden"
               name="Files"
               multiple
               @change="processFiles($event)"
               :id="'uploadResource_' + taskId" />
      </label>
    </div>
    <div class="task-history-file-info">
      Files attached shouldn't be larger than 1 MB.<br/>
      Accepted formats: {{ taskMessageAllowedFileFormats.join(', ') }}.
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters } from 'vuex'
  import vuescroll from 'vuescroll'
  import Avatar from 'vue-avatar'

  export default {
    name: 'task-history',
    props: {
      company: Number,
      taskId: {
        type: Number,
        required: true
      },
      newStatus: {
        type: Number
      },
      newAssignee: {
        type: Object
      },
      newBoard: {
        type: String
      },
      submitting: false
    },
    data () {
      return {
        messageForm: {
          text: '',
          files: []
        },
        loadingMessages: false,
        deleteInProgress: null,
        scrollBarOptions: {
          scrollPanel: {
            scrollingX: false,
            initialScrollY: '100%'
          },
          bar: {
            background: '#22b6cd',
            opacity: '0.4'
          }
        },
        taskHistory: []
      }
    },
    computed: {
      ...mapGetters([
        'taskStatuses',
        'taskMessageAllowedFileFormats',
        'getFirstName',
        'getLastName',
        'getUserId',
        'isAdmin'
      ]),
      nowDateTimeString () {
        const currentDate = new Date()
        const date = currentDate.getDate() < 10 ? ('0' + currentDate.getDate()) : currentDate.getDate()
        const month = currentDate.getMonth() < 9 ? ('0' + (currentDate.getMonth() + 1)) : (currentDate.getMonth() + 1)
        const year = currentDate.getFullYear()
        let hours = currentDate.getHours()
        let minutes = currentDate.getMinutes()
        const ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        hours = hours || 12
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        return date + '-' + month + '-' + year + ', ' + hours + ':' + minutes + ' ' + ampm
      },
      fileServerBase () {
        return api.serverContenImages
      }
    },
    methods: {
      processFiles (event) {
        let self = this
        let files = event.target.files
        Object.keys(files).map(function (key) {
          let file = files[key]
          let reader = new FileReader()
          let fileSize = (file.size / (1024 * 1024 * 25)).toFixed(2)
          if (fileSize > 1) {
            alert('Files attached shouldn\'t be larger than 25 MB.')
            return
          }
          reader.onload = function (e) {
            let fileName = file.name
            let valueTrimmed = fileName.replace(/\.[^/.]+$/, '')
            let extension = fileName.split('.').pop().toLowerCase()
            if (self.taskMessageAllowedFileFormats.indexOf(extension) === -1) {
              alert('Only accepted formats: ' + self.taskMessageAllowedFileFormats.join(', ') + '!')
              return
            }
            self.messageForm.files.push({
              name: valueTrimmed,
              body: e.target.result,
              extension: extension
            })
          }
          reader.readAsDataURL(file)
        })
      },
      messageSubmit (event) {
        if (this.messageForm.text === '' && !this.messageForm.files.length) {
          return
        }
        const createdMessageId = this.temporaryMessage()
        const createdMessage = this.taskHistory.find((item) => item.id === createdMessageId)
        const data = {
          taskId: this.taskId,
          text: this.messageForm.text,
          files: this.messageForm.files.length ? this.messageForm.files : null
        }
        if (this.company) {
          data['company'] = this.company
        }
        this.submitting = true
        this.$http.post(`${api.URLS.task}/message/submit`, data, api.headersAuthSettings)
          .then(() => {
            this.messageFormReset(event.target)
            this.getHistoryMessages()
            this.scrollMessages()
            this.refreshMessages()
            this.submitting = false
          }).catch(() => {
            createdMessage.notSent = true
            this.submitting = false
          })
      },
      getHistoryMessages () {
        let actionURL = `${api.URLS.task}/message/list/${this.taskId}`
        if (this.company) {
          actionURL += `?company=${this.company}`
        }
        this.$http.get(actionURL, api.headersAuthSettings)
          .then((res) => {
            this.taskHistory = res.body
            this.scrollMessages()
          }).catch(() => {})
      },
      deleteMessage (message) {
        this.deleteInProgress = message.id
        setTimeout(() => {
          message.deleted = true
          message.deletedBy = this.getFirstName + ' ' + this.getLastName.charAt(0) + '.'
          message.deletedOn = this.nowDateTimeString
          message.files = null
        }, 400)
        this.$http.delete(`${api.URLS.task}/message/${message.id}`, api.headersAuthSettings)
          .then((res) => {
            setTimeout(() => {
              this.deleteInProgress = null
            }, 400)
          })
          .catch((err) => { console.log(err) })
      },
      retrySendMessage (message) {
        message.notSent = false
        this.updateTaskHistory()
      },
      loadOldMessages () {
        if (this.loadingMessages) {
          return
        }
        this.loadingMessages = true
        setTimeout(() => {
          this.taskHistory.unshift(...this.taskHistory)
          this.loadingMessages = false
        }, 5000)
      },
      messageFormReset (form) {
        form.reset()
        this.messageForm.text = ''
        this.messageForm.files = []
      },
      removeMessageFile (index) {
        this.messageForm.files.splice(index, 1)
      },
      temporaryMessage () {
        const id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999)
        const message = {
          id: id,
          userName: 'You',
          userId: this.getUserId,
          clearOfficer: this.isAdmin,
          clearBot: false,
          date: this.nowDateTimeString,
          type: 1,
          deleted: false,
          text: this.messageForm.text
        }
        if (this.messageForm.files && this.messageForm.files.length) {
          message.files = []
          for (let i = 0; i < this.messageForm.files.length; i++) {
            message.files.push({
              name: this.messageForm.files[i]['name'],
              link: null
            })
          }
        }
        // this.taskHistory.push(message)
        return id
      },
      temporaryStatus (status) {
        const id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999)
        const message = {
          id: id,
          userName: 'You',
          userId: this.getUserId,
          clearOfficer: this.isAdmin,
          clearBot: false,
          date: this.nowDateTimeString,
          type: 2,
          status: status
        }
        this.taskHistory.push(message)
        return id
      },
      temporaryAssignee (assignee) {
        const id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999)
        const message = {
          id: id,
          userName: 'You',
          userId: this.getUserId,
          clearOfficer: this.isAdmin,
          clearBot: false,
          date: this.nowDateTimeString,
          type: 3,
          assigneeFullName: assignee.fullName,
          assigneeName: assignee.name,
          assigneeImage: assignee.image ? (api.serverUserImages + assignee.image) : null
        }
        this.taskHistory.push(message)
        return id
      },
      temporaryBoard (boardName) {
        const id = Math.floor(Math.random() * (999999999 - 999999 + 1) + 999999)
        const message = {
          id: id,
          userName: 'You',
          userId: this.getUserId,
          clearOfficer: this.isAdmin,
          clearBot: false,
          date: this.nowDateTimeString,
          type: 4,
          board: boardName
        }
        this.taskHistory.push(message)
        return id
      },
      scrollMessages () {
        const self = this
        setTimeout(function () {
          self.$refs['historyMsg'].scrollTo({
            y: '100%'
          }, 0, 'easeInQuad')
        }, 200)
      },
      refreshMessages () {
        this.$refs['historyMsg'].refresh()
      },
      handleScroll (vertical, horizontal, nativeEvent) {
        if (vertical.scrollTop <= 100) {
          // this.loadOldMessages()
        }
      },
      getStatusById (id) {
        return this.taskStatuses.find((item) => item.id === id)
      },
      isMineMessage (message) {
        return (this.isAdmin && (message.clearOfficer || message.clearBot)) || (!this.isAdmin && (!message.clearOfficer && !message.clearBot))
      },
      updateTaskHistory () {
        this.taskHistory = [].concat(this.taskHistory)
      },
      downloadFile (file, message) {
        let actionURL = `${api.URLS.content}/download-file`
        if (this.company) {
          actionURL += `?company=${this.company}`
        }
        let data = {
          type: 'task-history',
          content: this.taskId,
          message: message,
          file: file.file
        }
        let options = {
          ...api.headersAuthSettings,
          responseType: 'blob'
        }
        this.$http.post(actionURL, data, options).then((res) => {
          let data = new Blob([res['data']])
          if (window.navigator.msSaveBlob) {
            navigator.msSaveBlob(data, file.file)
          } else {
            const dataUrl = URL.createObjectURL(data)
            const link = document.createElement('A')
            link.setAttribute('href', dataUrl)
            link.setAttribute('download', file.file)
            link.click()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    components: {
      vuescroll,
      Avatar
    },
    mounted () {

    },
    created () {
      this.getHistoryMessages()
      // const messagesBody = document.querySelector('.task-history-body')
      // messagesBody.addEventListener('ps-scroll-up', function (event) {
      //   console.log(event)
      // })
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id || (to.params.companyId && from.params.companyId && to.params.companyId !== from.params.companyId)) {
          this.getHistoryMessages()
        }
      },
      newStatus (value) {
        this.temporaryStatus(value)
        this.scrollMessages()
      },
      newAssignee (value) {
        this.temporaryAssignee(value)
        this.scrollMessages()
      },
      newBoard (value) {
        this.temporaryBoard(value)
        this.scrollMessages()
      }
    }
  }
</script>

<style src="@/assets/scss/components/tasks/task-history.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TaskHistory.vue?5abe40be